/**
 * Returns a truncated string with character limit
 * @param description - string description to trunctate
 * @param charLimit - numeric character limit
 * @returns - truncated string
 */
export function truncate(description: string, charLimit: number): string {
  let truncDesc;

  if (description) {
    const strippedDesc = description.replace(/<.*?>/g, '');
    const chars = strippedDesc.split('');

    if (chars.length > charLimit) {
      truncDesc = chars.slice(0, charLimit - 1).join('');
      const lastSpaceIdx = truncDesc.lastIndexOf(' ');
      truncDesc = truncDesc.split('').splice(0, lastSpaceIdx).join('');
    } else {
      truncDesc = strippedDesc;
    }
  }

  return truncDesc;
}
